import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "collapsed-section-expander" }
const _hoisted_2 = { class: "collapsed-section-inner" }
const _hoisted_3 = { class: "collapsed-section-text-above" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1)
const _hoisted_5 = { class: "end-tracker" }
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}

import { ref, computed, onMounted, onBeforeMount } from "vue";
import { debug as d } from "debug";
import { ObserveVisibility as vObserveVisibility } from "vue3-observe-visibility";
import { Analytics } from "../../services/analytics/analytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'collapsed-section',
  props: {
    showDoneButton: { type: Boolean, default: false }
  },
  setup(__props: any) {

const debug = d("cs.CollapsedSectionComponent");

const props = __props;

const expanded = ref(false);
const expander = ref<HTMLElement | null>(null);

const jExpander = computed(() => $(expander.value as HTMLElement));

const slideDownOptions = {
  duration: 1000,
  easing: "swing",
};

const slideUpOptions = {
  duration: 500,
  easing: "swing",
};

const refExpander = ref<HTMLElement | null>(null);

const expand = () => {
  if (!expanded.value) {
    expanded.value = true;
    debug("Expanding");
    Analytics.action("Expanded Section", "SectionActions", {
      collapsedSectionTitle: refExpander.value?.querySelector(".collapsed-section-text-above")
        ?.textContent,
    });
    jExpander.value?.stop();
    jExpander.value?.slideDown(slideDownOptions);
  }
};

const collapse = () => {
  if (expanded.value) {
    expanded.value = false;
    debug("Collapsing");
    Analytics.action("Collapsed Section", "SectionActions", {
      collapsedSectionTitle: refExpander.value?.querySelector(".collapsed-section-text-above")
        ?.textContent,
    });

    const expanderHeight = refExpander.value?.clientHeight || 0;
    jExpander.value.stop();
    jExpander.value.slideUp(slideUpOptions);
    const pageElement = refExpander.value?.closest(".page-content");
    if (pageElement) {
      const originalScrollTop = pageElement.scrollTop;
      $(pageElement).animate(
        { scrollTop: originalScrollTop - expanderHeight },
        slideUpOptions.duration,
      );
    }
  }
};

const toggle = () => {
  if (!expanded.value) {
    expand();
  } else {
    collapse();
  }
};

const done = () => {
  collapse();
};

onMounted(() => {
  debug("Running mounted");
  jExpander.value.slideUp(0);
  debug("Finished mounted handler");
});

onBeforeMount(() => {
  debug("beforeDestroy");
});

const onVisibilityChanged = () => {
  // Nothing to do
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ expanded: expanded.value }, "collapsed-section collapsed-section-bootstrap"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(expanded.value ? 'btn btn-primary-minus' : 'btn btn-primary-plus'),
        onClick: toggle,
        type: "button"
      }, _toDisplayString(expanded.value ? "Hide" : "Show"), 3)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "text-above")
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", {
      ref_key: "expander",
      ref: expander,
      class: "collapsed-section-text-below"
    }, [
      _renderSlot(_ctx.$slots, "text-below"),
      _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
        [_unref(vObserveVisibility), onVisibilityChanged]
      ]),
      (props.showDoneButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: done,
              type: "button"
            }, "Done")
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ], 2))
}
}

})